import * as THREE from 'three';

import { Model } from '../lib/Model';

export class ScenePointLight extends Model {
    private lightPosition: any;

    constructor(viewer, name, lightPosition) {
        super(name, viewer);
        this.model = new THREE.PointLight(0xffffff, 0.1);
        if (viewer.debug) {
            this.viewer.scene.add(new THREE.PointLightHelper(this.model, 0.1, 0xffffff));
        }
        this.lightPosition = lightPosition;
    }

    init() {
        this.model.position.copy(this.lightPosition);
        this.model.castShadow = false;

        this.model.shadow.camera.far = 0.5;
        this.model.shadow.camera.near = 0.01;

        if (this.viewer.debug) {
            const cameraHelper = new THREE.CameraHelper(this.model.shadow.camera);
            this.viewer.scene.add(cameraHelper);
        }

        super.init();
    }

    // eslint-disable-next-line class-methods-use-this
    animate() {}

    dispose() {
        this.model.shadow.dispose();
        super.dispose();
    }
}
